var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.25H8.25V9.5H5.75V18.25ZM10.75 18.25H13.25V5.75H10.75V18.25ZM15.75 18.25H18.25V13.25H15.75V18.25ZM3.25 23.25C2.5625 23.25 1.97375 23.0054 1.48375 22.5163C0.994583 22.0263 0.75 21.4375 0.75 20.75V3.25C0.75 2.5625 0.994583 1.97375 1.48375 1.48375C1.97375 0.994583 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.0263 0.994583 22.5163 1.48375C23.0054 1.97375 23.25 2.5625 23.25 3.25V20.75C23.25 21.4375 23.0054 22.0263 22.5163 22.5163C22.0263 23.0054 21.4375 23.25 20.75 23.25H3.25Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.e453d69c2a48692d81d552a8d4f4d67b.svg";
export { ForwardRef as ReactComponent };